/* eslint-disable import/no-extraneous-dependencies */
import { styled } from '@linaria/react';
import cx from 'classnames';

export interface LinkButtonProps {
  children: React.ReactElement | string;
  target?: '_self' | '_target';
  href?: string;
  height?: number | string;
  active?: boolean;
}

const BaseButton = styled.a`
  border: none;
  border-radius: 4px;
  font-size: 15px;
  cursor: pointer;
  text-decoration: none;
  height: 31px;
  line-height: 31px;
`;

const AnueButton = styled(BaseButton)`
  color: #8f8f8f;
  background-color: white;
  height: 44px;
  min-width: 105px;
  border-width: 0;
  font-size: 16px;
  cursor: pointer;
  line-height: 44px;
  letter-spacing: 0.5px;
  text-align: center;
  border-radius: 2px;
  display: inline-block;

  :hover {
    color: #e03f19;
  }

  &.active {
    background-color: #e03f19;
    color: white;
  }
`;

export function Anue({
  children,
  href = '/',
  target = '_self',
  active = false,
}: LinkButtonProps) {
  return (
    <AnueButton href={href} target={target} className={cx({ active })}>
      {children}
    </AnueButton>
  );
}

export default Anue;
